import React from "react";
import { usePromise } from "react-use";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";

export default withStyles({}, { name: "LcButtonField" })(
  ({
    classes,
    name,
    label: labelProp = name,
    value: valueProp,
    disabled: disabledProp,
    onClick,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    ...props
  }) => {
    const mounted = usePromise();
    return (
      <FieldComponent name={name}>
        {({ form, field }) => {
          const { disabled, label, value } = getFieldStatus(
            form,
            field,
            valueProp,
            labelProp,
            disabledProp
          );

          return (
            <Button
              {...props}
              disabled={disabled}
              onClick={e => onClick && onClick(e, form, field, value, mounted)}
            >
              {label}
            </Button>
          );
        }}
      </FieldComponent>
    );
  }
);
